import api from './api';

/**
 * INVENTORY-TRUST.1e — client for the venue-wide inventory balance drift report.
 * GET /admin/venue/:venueId/inventory/drift (ADMIN_ONLY, read-only).
 */

export interface DriftGroup {
  inventoryItemId: string;
  itemName: string | null;
  locationId: string | null;
  locationName: string | null;
  lotId: string | null;
  ownershipAccountId: string | null;
  ledgerQuantity: number;
  balanceQuantity: number | null;
  difference: number;
  kind: 'MISMATCH' | 'ORPHAN_BALANCE' | 'ORPHAN_GROUP';
}

export interface DriftReport {
  venueId: string;
  generatedAt: string;
  clean: boolean;
  summary: { mismatched: number; orphanBalances: number; orphanGroups: number; totalGroupsChecked: number };
  affectedItemLocations: Array<{ inventoryItemId: string; itemName: string | null; locationId: string | null; locationName: string | null }>;
  groups: DriftGroup[];
}

const inventoryDriftService = {
  getDrift: async (venueId: string): Promise<DriftReport> => {
    const response = await api.get(`/admin/venue/${venueId}/inventory/drift`);
    return response.data;
  },
};

export default inventoryDriftService;
